(() => {
  const start = () => {
    const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (preference.matches || window.Shopify?.designMode || !('IntersectionObserver' in window)) return;
    const targets = document.querySelectorAll(
      '.orda-editorial__grid, .orda-feature__image, .orda-feature__copy, ' +
      '.orda-section-heading, .orda-stories__grid > article, .orda-steps__grid > *, ' +
      '.orda-glass-guide__photo, .orda-glass-guide > div:last-child, ' +
      '.orda-about-image, .orda-about-columns > div'
    );
    const reveal = (element) => {
      element.classList.add('is-revealed');
      observer.unobserve(element);
    };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => { if (entry.isIntersecting) reveal(entry.target); });
    }, { threshold: 0, rootMargin: '0px 0px -24px 0px' });
    targets.forEach((element) => {
      if (element.getBoundingClientRect().top < window.innerHeight) return;
      element.classList.add('orda-reveal');
      observer.observe(element);
      element.addEventListener('focusin', () => reveal(element), { once: true });
    });
    preference.addEventListener('change', () => {
      if (!preference.matches) return;
      observer.disconnect();
      targets.forEach((element) => element.classList.add('is-revealed'));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
